module.exports = __webpack_public_path__ + "img/shipper-mp-code.3a99835d.jpg";